import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var OwnerType = /*#__PURE__*/function (OwnerType) {
  OwnerType[OwnerType["OWNER_TYPE_INVALID"] = 0] = "OWNER_TYPE_INVALID";
  OwnerType[OwnerType["OWNER_TYPE_PARTNER"] = 1] = "OWNER_TYPE_PARTNER";
  OwnerType[OwnerType["OWNER_TYPE_ACCOUNT_GROUP"] = 2] = "OWNER_TYPE_ACCOUNT_GROUP";
  OwnerType[OwnerType["OWNER_TYPE_SYSTEM"] = 3] = "OWNER_TYPE_SYSTEM";
  return OwnerType;
}(OwnerType || {});
// *********************************

function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateEmailBuilderTemplateRequest {
  static fromProto(proto) {
    let m = new CreateEmailBuilderTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.ownerType) {
      m.ownerType = enumStringToValue(OwnerType, proto.ownerType);
    }
    if (proto.parent) {
      m.parent = TemplateReference.fromProto(proto.parent);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerType !== 'undefined') {
      toReturn['ownerType'] = this.ownerType;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.appNamespace !== 'undefined') {
      toReturn['appNamespace'] = this.appNamespace;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.templateDisplayName !== 'undefined') {
      toReturn['templateDisplayName'] = this.templateDisplayName;
    }
    if (typeof this.templateJson !== 'undefined') {
      toReturn['templateJson'] = this.templateJson;
    }
    if (typeof this.templateHtml !== 'undefined') {
      toReturn['templateHtml'] = this.templateHtml;
    }
    if (typeof this.templateSubject !== 'undefined') {
      toReturn['templateSubject'] = this.templateSubject;
    }
    if (typeof this.parent !== 'undefined' && this.parent !== null) {
      toReturn['parent'] = 'toApiJson' in this.parent ? this.parent.toApiJson() : this.parent;
    }
    return toReturn;
  }
}
class DeleteEmailBuilderTemplateRequest {
  static fromProto(proto) {
    let m = new DeleteEmailBuilderTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.ownerType) {
      m.ownerType = enumStringToValue(OwnerType, proto.ownerType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerType !== 'undefined') {
      toReturn['ownerType'] = this.ownerType;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.appNamespace !== 'undefined') {
      toReturn['appNamespace'] = this.appNamespace;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class EmailBuilderTemplate {
  static fromProto(proto) {
    let m = new EmailBuilderTemplate();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.templateDisplayName !== 'undefined') {
      toReturn['templateDisplayName'] = this.templateDisplayName;
    }
    if (typeof this.templateJson !== 'undefined') {
      toReturn['templateJson'] = this.templateJson;
    }
    if (typeof this.previewUrl !== 'undefined') {
      toReturn['previewUrl'] = this.previewUrl;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.templateHtml !== 'undefined') {
      toReturn['templateHtml'] = this.templateHtml;
    }
    if (typeof this.templateSubject !== 'undefined') {
      toReturn['templateSubject'] = this.templateSubject;
    }
    return toReturn;
  }
}
class GetEmailBuilderTemplateRequest {
  static fromProto(proto) {
    let m = new GetEmailBuilderTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.ownerType) {
      m.ownerType = enumStringToValue(OwnerType, proto.ownerType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerType !== 'undefined') {
      toReturn['ownerType'] = this.ownerType;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.appNamespace !== 'undefined') {
      toReturn['appNamespace'] = this.appNamespace;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class GetEmailBuilderTemplateResponse {
  static fromProto(proto) {
    let m = new GetEmailBuilderTemplateResponse();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = EmailBuilderTemplate.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class GetEmailBuilderTemplatesRequest {
  static fromProto(proto) {
    let m = new GetEmailBuilderTemplatesRequest();
    m = Object.assign(m, proto);
    if (proto.ownerType) {
      m.ownerType = enumStringToValue(OwnerType, proto.ownerType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerType !== 'undefined') {
      toReturn['ownerType'] = this.ownerType;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.appNamespace !== 'undefined') {
      toReturn['appNamespace'] = this.appNamespace;
    }
    if (typeof this.templateIds !== 'undefined') {
      toReturn['templateIds'] = this.templateIds;
    }
    return toReturn;
  }
}
class GetEmailBuilderTemplatesResponse {
  static fromProto(proto) {
    let m = new GetEmailBuilderTemplatesResponse();
    m = Object.assign(m, proto);
    if (proto.templates) {
      m.templates = proto.templates.map(EmailBuilderTemplate.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templates !== 'undefined' && this.templates !== null) {
      toReturn['templates'] = 'toApiJson' in this.templates ? this.templates.toApiJson() : this.templates;
    }
    return toReturn;
  }
}
class ListEmailBuilderTemplatesRequest {
  static fromProto(proto) {
    let m = new ListEmailBuilderTemplatesRequest();
    m = Object.assign(m, proto);
    if (proto.ownerType) {
      m.ownerType = enumStringToValue(OwnerType, proto.ownerType);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerType !== 'undefined') {
      toReturn['ownerType'] = this.ownerType;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.appNamespace !== 'undefined') {
      toReturn['appNamespace'] = this.appNamespace;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListEmailBuilderTemplatesResponse {
  static fromProto(proto) {
    let m = new ListEmailBuilderTemplatesResponse();
    m = Object.assign(m, proto);
    if (proto.templates) {
      m.templates = proto.templates.map(EmailBuilderTemplate.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templates !== 'undefined' && this.templates !== null) {
      toReturn['templates'] = 'toApiJson' in this.templates ? this.templates.toApiJson() : this.templates;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class SearchEmailBuilderTemplatesRequest {
  static fromProto(proto) {
    let m = new SearchEmailBuilderTemplatesRequest();
    m = Object.assign(m, proto);
    if (proto.ownerType) {
      m.ownerType = enumStringToValue(OwnerType, proto.ownerType);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerType !== 'undefined') {
      toReturn['ownerType'] = this.ownerType;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.appNamespace !== 'undefined') {
      toReturn['appNamespace'] = this.appNamespace;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class SearchEmailBuilderTemplatesResponse {
  static fromProto(proto) {
    let m = new SearchEmailBuilderTemplatesResponse();
    m = Object.assign(m, proto);
    if (proto.templates) {
      m.templates = proto.templates.map(EmailBuilderTemplate.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    if (proto.hits) {
      m.hits = parseInt(proto.hits, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templates !== 'undefined' && this.templates !== null) {
      toReturn['templates'] = 'toApiJson' in this.templates ? this.templates.toApiJson() : this.templates;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    if (typeof this.hits !== 'undefined') {
      toReturn['hits'] = this.hits;
    }
    return toReturn;
  }
}
class SuggestContentRequest {
  static fromProto(proto) {
    let m = new SuggestContentRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prompt !== 'undefined') {
      toReturn['prompt'] = this.prompt;
    }
    return toReturn;
  }
}
class SuggestContentResponse {
  static fromProto(proto) {
    let m = new SuggestContentResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    return toReturn;
  }
}
class TemplateReference {
  static fromProto(proto) {
    let m = new TemplateReference();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appNamespace !== 'undefined') {
      toReturn['appNamespace'] = this.appNamespace;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class UpdateEmailBuilderTemplateRequest {
  static fromProto(proto) {
    let m = new UpdateEmailBuilderTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.ownerType) {
      m.ownerType = enumStringToValue(OwnerType, proto.ownerType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerType !== 'undefined') {
      toReturn['ownerType'] = this.ownerType;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.appNamespace !== 'undefined') {
      toReturn['appNamespace'] = this.appNamespace;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.templateDisplayName !== 'undefined') {
      toReturn['templateDisplayName'] = this.templateDisplayName;
    }
    if (typeof this.templateJson !== 'undefined') {
      toReturn['templateJson'] = this.templateJson;
    }
    if (typeof this.templateHtml !== 'undefined') {
      toReturn['templateHtml'] = this.templateHtml;
    }
    if (typeof this.templateSubject !== 'undefined') {
      toReturn['templateSubject'] = this.templateSubject;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'email-builder-api.vendasta-local.com',
  'test': '',
  'demo': 'email-builder-demo.apigateway.co',
  'prod': 'email-builder-prod.apigateway.co',
  'production': 'email-builder-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ContentGenerationApiService = /*#__PURE__*/(() => {
  class ContentGenerationApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    suggestContent(r) {
      const request = r.toApiJson ? r : new SuggestContentRequest(r);
      return this.http.post(this._host + "/emailbuilder.v1.ContentGeneration/SuggestContent", request.toApiJson(), this.apiOptions()).pipe(map(resp => SuggestContentResponse.fromProto(resp)));
    }
  }
  ContentGenerationApiService.ɵfac = function ContentGenerationApiService_Factory(t) {
    return new (t || ContentGenerationApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ContentGenerationApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ContentGenerationApiService,
    factory: ContentGenerationApiService.ɵfac,
    providedIn: 'root'
  });
  return ContentGenerationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let TemplatesApiService = /*#__PURE__*/(() => {
  class TemplatesApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createEmailBuilderTemplate(r) {
      const request = r.toApiJson ? r : new CreateEmailBuilderTemplateRequest(r);
      return this.http.post(this._host + "/emailbuilder.v1.Templates/CreateEmailBuilderTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateEmailBuilderTemplate(r) {
      const request = r.toApiJson ? r : new UpdateEmailBuilderTemplateRequest(r);
      return this.http.post(this._host + "/emailbuilder.v1.Templates/UpdateEmailBuilderTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getEmailBuilderTemplate(r) {
      const request = r.toApiJson ? r : new GetEmailBuilderTemplateRequest(r);
      return this.http.post(this._host + "/emailbuilder.v1.Templates/GetEmailBuilderTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEmailBuilderTemplateResponse.fromProto(resp)));
    }
    getEmailBuilderTemplates(r) {
      const request = r.toApiJson ? r : new GetEmailBuilderTemplatesRequest(r);
      return this.http.post(this._host + "/emailbuilder.v1.Templates/GetEmailBuilderTemplates", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEmailBuilderTemplatesResponse.fromProto(resp)));
    }
    listEmailBuilderTemplates(r) {
      const request = r.toApiJson ? r : new ListEmailBuilderTemplatesRequest(r);
      return this.http.post(this._host + "/emailbuilder.v1.Templates/ListEmailBuilderTemplates", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListEmailBuilderTemplatesResponse.fromProto(resp)));
    }
    deleteEmailBuilderTemplate(r) {
      const request = r.toApiJson ? r : new DeleteEmailBuilderTemplateRequest(r);
      return this.http.post(this._host + "/emailbuilder.v1.Templates/DeleteEmailBuilderTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    searchEmailBuilderTemplates(r) {
      const request = r.toApiJson ? r : new SearchEmailBuilderTemplatesRequest(r);
      return this.http.post(this._host + "/emailbuilder.v1.Templates/SearchEmailBuilderTemplates", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchEmailBuilderTemplatesResponse.fromProto(resp)));
    }
  }
  TemplatesApiService.ɵfac = function TemplatesApiService_Factory(t) {
    return new (t || TemplatesApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  TemplatesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TemplatesApiService,
    factory: TemplatesApiService.ɵfac,
    providedIn: 'root'
  });
  return TemplatesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************

var AppNamespace = /*#__PURE__*/function (AppNamespace) {
  AppNamespace["DEV_SANDBOX"] = "developer_sandbox";
  AppNamespace["CAMPAIGNS"] = "campaigns";
  AppNamespace["AUTOMATIONS"] = "automations";
  AppNamespace["EMAIL_LIBRARY"] = "email_library";
  AppNamespace["REPUTATION_REVIEW_REQUEST"] = "reputation_management/review_request";
  return AppNamespace;
}(AppNamespace || {});
let TemplatesService = /*#__PURE__*/(() => {
  class TemplatesService {
    constructor(api) {
      this.api = api;
    }
    createNewTemplate(ownerType, ownerId, appNamespace, templateId, templateDisplayName, templateJSON, templateHTML, templateSubject, parent) {
      const req = new CreateEmailBuilderTemplateRequest({
        ownerType: ownerType,
        ownerId: ownerId,
        appNamespace: appNamespace,
        templateId: templateId,
        templateDisplayName: templateDisplayName,
        templateJson: templateJSON,
        templateHtml: templateHTML,
        templateSubject: templateSubject,
        parent: parent
      });
      return this.api.createEmailBuilderTemplate(req).pipe(map(() => null));
    }
    updateExistingTemplate(ownerType, ownerId, appNamespace, templateId, templateDisplayName, templateJSON, templateHTML, templateSubject) {
      const req = new UpdateEmailBuilderTemplateRequest({
        ownerType: ownerType,
        ownerId: ownerId,
        appNamespace: appNamespace,
        templateId: templateId,
        templateDisplayName: templateDisplayName,
        templateJson: templateJSON,
        templateHtml: templateHTML,
        templateSubject: templateSubject
      });
      return this.api.updateEmailBuilderTemplate(req).pipe(map(() => null));
    }
    getTemplate(ownerType, ownerId, appNamespace, templateId) {
      const req = new GetEmailBuilderTemplateRequest({
        ownerType: ownerType,
        ownerId: ownerId,
        appNamespace: appNamespace,
        templateId: templateId
      });
      return this.api.getEmailBuilderTemplate(req).pipe(map(resp => resp.template));
    }
    getTemplates(ownerType, ownerId, appNamespace, templateIds) {
      const req = new GetEmailBuilderTemplatesRequest({
        ownerType: ownerType,
        ownerId: ownerId,
        appNamespace: appNamespace,
        templateIds: templateIds
      });
      return this.api.getEmailBuilderTemplates(req).pipe(map(resp => resp.templates));
    }
    getTemplateHTML(ownerType, ownerId, appNamespace, templateId) {
      const req = new GetEmailBuilderTemplateRequest({
        ownerType: ownerType,
        ownerId: ownerId,
        appNamespace: appNamespace,
        templateId: templateId
      });
      return this.api.getEmailBuilderTemplate(req).pipe(map(resp => resp?.template?.templateHtml));
    }
    listTemplates(ownerType, ownerId, appNamespace, searchTerm, cursor, pageSize) {
      const req = new ListEmailBuilderTemplatesRequest({
        ownerType: ownerType,
        ownerId: ownerId,
        appNamespace: appNamespace,
        searchTerm: searchTerm,
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      });
      return this.api.listEmailBuilderTemplates(req).pipe(map(v => {
        v.templates = v.templates || [];
        return v;
      }));
    }
    searchTemplates(ownerType, ownerId, appNamespace, searchTerm, pageSize, cursor) {
      const req = new SearchEmailBuilderTemplatesRequest({
        ownerType: ownerType,
        ownerId: ownerId,
        appNamespace: appNamespace,
        searchTerm: searchTerm,
        pagingOptions: new PagedRequestOptions({
          cursor: cursor,
          pageSize: pageSize
        })
      });
      return this.api.searchEmailBuilderTemplates(req).pipe(map(v => {
        v.templates = v.templates || [];
        return v;
      }));
    }
    deleteTemplate(ownerType, ownerId, appNamespace, templateId) {
      const req = new DeleteEmailBuilderTemplateRequest({
        ownerType: ownerType,
        ownerId: ownerId,
        appNamespace: appNamespace,
        templateId: templateId
      });
      return this.api.deleteEmailBuilderTemplate(req);
    }
  }
  TemplatesService.ɵfac = function TemplatesService_Factory(t) {
    return new (t || TemplatesService)(i0.ɵɵinject(TemplatesApiService));
  };
  TemplatesService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TemplatesService,
    factory: TemplatesService.ɵfac,
    providedIn: 'root'
  });
  return TemplatesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ContentGenerationService = /*#__PURE__*/(() => {
  class ContentGenerationService {
    constructor(api) {
      this.api = api;
    }
    suggestContent(prompt) {
      const req = new SuggestContentRequest({
        prompt: prompt
      });
      return this.api.suggestContent(req).pipe(map(resp => resp.message));
    }
  }
  ContentGenerationService.ɵfac = function ContentGenerationService_Factory(t) {
    return new (t || ContentGenerationService)(i0.ɵɵinject(ContentGenerationApiService));
  };
  ContentGenerationService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ContentGenerationService,
    factory: ContentGenerationService.ɵfac,
    providedIn: 'root'
  });
  return ContentGenerationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Access, AppNamespace, ContentGenerationService, CreateEmailBuilderTemplateRequest, DeleteEmailBuilderTemplateRequest, EmailBuilderTemplate, GetEmailBuilderTemplateRequest, GetEmailBuilderTemplateResponse, GetEmailBuilderTemplatesRequest, GetEmailBuilderTemplatesResponse, ListEmailBuilderTemplatesRequest, ListEmailBuilderTemplatesResponse, OwnerType, PagedRequestOptions, PagedResponseMetadata, SearchEmailBuilderTemplatesRequest, SearchEmailBuilderTemplatesResponse, SuggestContentRequest, SuggestContentResponse, TemplateReference, TemplatesService, UpdateEmailBuilderTemplateRequest };
